<template>
  <button class="stock-watchlist-button" type="button" :disabled="busy || !symbol" :title="error || label" :aria-label="label" :aria-pressed="favorite" @click="toggle">
    <svg v-if="!busy" viewBox="0 0 32 32" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M25 17c3-3 4-5 4-8a7 7 0 0 0-13-3A7 7 0 0 0 3 9c0 6 6 11 13 17" /><path v-if="favorite" d="m18 22 4 4 7-9" /><path v-else d="M23 19v10m-5-5h10" /></svg>
    <i v-else class="el-icon-loading" aria-hidden="true"></i>
  </button>
</template>
<script>
import request from '@/utils/request'
import { getToken } from '@/utils/cache'
import { stockSelection } from './stockSelection'
export default {
  props: { symbol: String },
  data: () => ({ favorite: false, ready: false, busy: false, error: '', sequence: 0 }),
  computed: {
    stock() { return stockSelection({ symbol: this.symbol }) },
    code() { return ['hk', 'us'].includes(this.stock.market) ? this.stock.code.slice(2) : this.stock.symbol.split('.')[0] },
    label() { return !this.ready ? '查询自选状态' : this.favorite ? '取消自选' : '添加自选' }
  },
  watch: { symbol: { immediate: true, handler() { this.load() } } },
  beforeDestroy() { this.sequence++ },
  methods: {
    async load() {
      const sequence = ++this.sequence
      this.ready = false; this.favorite = false; this.error = ''; this.busy = false
      if (!this.symbol || !getToken()) return
      this.busy = true
      try {
        const result = await request({ url: 'vexe/v1/stock/favCode', method: 'get', params: { codes: this.code } })
        if (sequence !== this.sequence) return
        if (!Array.isArray(result) || !result.length) throw new Error('自选状态查询失败，点击重试')
        this.favorite = Number(result[0].fav) === 1; this.ready = true
      } catch (error) { if (sequence === this.sequence) this.error = error.message }
      finally { if (sequence === this.sequence) this.busy = false }
    },
    async toggle() {
      if (this.busy) return
      if (!getToken()) { this.$message.warning('请先登录'); return }
      if (!this.ready) { this.load(); return }
      const sequence = this.sequence, remove = this.favorite
      const data = { codes: this.code }
      if (!remove) data.type = this.stock.market === 'us' ? 2 : this.stock.market === 'hk' ? 1 : 0
      this.busy = true; this.error = ''
      try {
        const result = await request({ url: `vexe/v1/user/${remove ? 'removeOptional' : 'createOptional'}`, method: 'post', data })
        if (result === 0 || result === undefined) return
        // Refresh the list even if the user changed stocks during the write.
        this.$emit('updated')
        if (sequence !== this.sequence) return
        this.favorite = !remove; this.$message.success(remove ? '已取消自选' : '已添加自选')
      } catch (error) { if (sequence === this.sequence) { this.error = error.message; this.$message.error('操作失败，请刷新自选状态后重试'); this.ready = false } }
      finally { if (sequence === this.sequence) this.busy = false }
    }
  }
}
</script>
<style scoped>
.stock-watchlist-button { flex: 0 0 34px; width: 34px; height: 34px; display: inline-flex; align-items: center; justify-content: center; border: 0; border-radius: 5px; padding: 5px; background: transparent; color: var(--theme-muted); cursor: pointer; }
.stock-watchlist-button svg { width: 26px; height: 26px; }
.stock-watchlist-button[aria-pressed=true], .stock-watchlist-button:hover { color: var(--theme-accent); }
.stock-watchlist-button:disabled { opacity: .5; cursor: wait; }
.stock-watchlist-button:focus-visible { outline: 2px solid var(--theme-accent); }
</style>
